export default {
  banner: {
    title: "Automotive IDaaS Solution",
    subtitle:
      "Construct an efficient, secure identity and access management system to facilitate digital transformation in automotive industry.",
  },
  marquee: {
    item1: {
      title1: "TOYOTA",
      desc1:
        "One of the world's top ten automobile industry companies, and the largest in Japan.",
      title2: "Refine access management",
      desc2:
        "Authing provides an identity management infrastructure that allows us to manage accounts securely and efficiently. In addition, Authing's cloud-native architecture supports elastic scaling to meet our future expansion.",
    },
    item2: {
      title1: "NavInfo",
      desc1:
        "China's leading enterprise of navigation maps, dynamic traffic information, and location big data solutions.",
      title2: "Enhance authentication security",
      desc2:
        "With the rapid growth of enterprises, identity data is increasingly fragmented across systems. The IDaaS built by Authing allows us to unify and synchronize data across multiple applications, enhancing security while improving efficiency.",
    },
    item3: {
      title1: "A leading global car manufacturer",
      desc1:
        "One of the world's top four car manufacturers, it tops the car sales charts in China year after year.",
      title2: "Improve development efficiency",
      desc2:
        "Authing's federated authentication capabilities enable us to quickly federate different identity providers to achieve authentication, greatly reducing development and operation costs, and saving valuable time and resources.",
    },
    item4: {
      title1: "A Tier 1 parts manufacturer",
      desc1:
        "It is one of the top five global automotive suppliers with operations on five continents.",
      title2: "Support 100,000+ users",
      desc2:
        "Authing products have high API coverage and support SDKs in mainstream languages, enabling us to conveniently invoke SDKs. And the underlying architecture of cloud-native can stably support hundreds of thousands of our users.",
    },
  },
  question: {
    title: "The digital transformation of automotive is imminent",
    cardOne: {
      title: "Risk of leakage of drawing secrets",
      descli1:
        "The rapid development of new energy car-making forces has increased the rate of talent turnover in the industry. The scattered authority management  for new and old business systems may cause leakage of key technical and data information.",
      descli2:
        "The business logic of permission management is complex, and the self-research system requires a lot of R&D costs; if the system is expanded in the future according to business needs, it needs to be built repeatedly, and the ROI is low.",
    },
    cardTwo: {
      title: "Complexity of sub-brand and supplier data",
      descli1:
        "Mature car companies are often divided into multiple sub-brands. The identity and data of different sub-brands should do data isolation to achieve the purpose of refined management.",
      descli2:
        "The automotive manufacturing chain is complex, with many upstream and downstream suppliers. These suppliers also need to be properly maintained - but this will add additional management costs to internal IT.",
    },
    cardThree: {
      title: "Shortages of Windows AD",
      descli1:
        "High prices, complex operations and high demands on corporate budgets and manpower;",
      descli2:
        "Weak compatibility and incompatibility with emerging applications;",
      descli3:
        "Single AD multi-domain coupling, multi-domain devices, applications, personnel have the risk of affecting each other.",
    },
    cardFour: {
      title: "Fragmentation of identity data ",
      descli1:
        "People in application A cannot correspond with application B one by one, making data interoperability and integration difficult.",
      descli2:
        "Employees need to be authenticated several times when using different business systems, making operation inefficient.",
      descli3:
        "Frequent staff turnover and a large number of supernumeraries lead to complex and inefficient operations and maintenance work.",
    },
  },
  advantage: {
    item1: {
      title:
        "Create fine-grained access management to protect key car-making secrets",
      desc:
        "Authing provides RBAC, ABAC, NGAC models to help enterprises establish appropriate authority control policies for different scenarios. Developers only need to access the API/SDK to efficiently implement authority management. They can also dynamically adjust employee access rights through Pipeline and Webhook extension capabilities.",
      alt: "",
    },
    item2: {
      title:
        "Unify the management of identities to improve operational efficiency",
      desc: `Managing the identity of external suppliers, sub-brands, and subordinate 4s stores with the "user group" or "multi-tenant" structure can improve the efficiency of informationization of car companies. In addition, each supplier can maintain its own personnel rights within its own tenant, creating a unified identity system internally and externally.`,
      alt: "",
    },
    item3: {
      title: "Complement AD shortages to support enterprise business expansion",
      desc:
        "Authing supports standard protocols such as OIDC, SAML, Oauth, CAS, and LDAP, covering B/S system solutions for AD; and supports automated synchronization of Windows AD identity directory and OU group information, helping enterprises decouple the burden of AD system authentication and improve scalability and convenience.",
      alt: "",
    },
    item4: {
      title:
        "Establish SSO+ synchronization platform to integrate data across systems",
      desc: `Authing pre-integrate 2000+ common applications, which can help enterprises efficiently establish single sign-on, unified identity authentication, and "manage and synchronize" multiple system accounts in one place, building the data interoperability foundation for expanding automotive manufacturing.`,
      alt: "",
    },
  },
};
